<div
	[formGroup]="formLogin"
	class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden"
>
	<div class="grid justify-content-center p-2 lg:p-0" style="min-width: 80%">
		<div class="col-12 mt-5 xl:mt-0 text-center">
			<img
				src="assets/img/logo_white.png"
				class="mb-5 mt-4"
				style="border-radius: 5px"
			/>
		</div>
		<div
			class="col-10 xl:col-5"
			style="
				border-radius: 56px;
				padding: 0.3rem;
				background: linear-gradient(
					180deg,
					rgba(255, 255, 255, 0.35) 40%,
					rgba(255, 255, 255, 0.25) 80%
				);
				border: solid 2px rgba(255, 255, 255, 0.25);
			"
		>
			<div
				class="h-full w-full m-0 py-7 px-4 form-login" >
				<div class="text-center mb-5">
					<div
						class="text-900 text-3xl font-medium mb-3"
						style="font-family: Albert Sans Regular"
					>
						Bienvenido
					</div>
					<span
						class="font-medium"
						style="font-family: Albert Sans Regular"
						>Accede para continuar</span
					>
				</div>
				<div class="w-full md:w-10 mx-auto">
					<label
						for="email1"
						style="font-family: Albert Sans Regular; color: black"
						class="block text-l font-medium mb-2"
						>Email</label
					>
					<input
						id="email1"
						type="email"
						formControlName="email"
						pInputText
						autocomplete="new-email"
						class="w-full mb-3"
					/>

					<label
						for="password"
						class="block font-medium text-l mb-2"
						style="font-family: Albert Sans Regular; color: black"
						>Contraseña</label
					>
					<input
						id="password"
						type="password"
						autocomplete="new-password"
						formControlName="password"
						pPassword
						[feedback]="false"
						class="w-full mb-3"
					/>

					<div class="flex align-items-center justify-content-between mb-5">
						<div class="flex align-items-center"></div>
						<a
							class="font-medium no-underline ml-2 text-right cursor-pointer"
							(click)="showForgotten()"
							style="font-family: Albert Sans Light"
						>
							Recuperar contraseña
						</a>
					</div>
					

					<div class="w-100 mb-5 text-center font-medium no-underline ml-2 cursor-pointer text-black" style="font-family: Albert Sans Light">
							Al entrar acepta los <b (click)="goTo('conditions-general')">Condiciones generales de uso</b> y <b (click)="goTo('privacy-policy')">Políticas de privacidad</b>
					</div>

					<button
						*ngIf="!loading"
						pButton
						pRipple
						label="Entrar"
						class="w-full p-3 text-xl p-button-rounded"
						(click)="login()"
					></button>

					<div *ngIf="!loading" class="text-center mt-4 version">
						{{versionApp}}
					</div>


					<div *ngIf="loading" class="text-center">
						<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Modal para recuperación de contraseña -->
<p-dialog
	[(visible)]="forgotten"
	header="Recuperar contraseña"
	[modal]="true"
	[style]="{ width: '50vw' }"
>
	<div class="w-full md:w-10 mx-auto">
		<label for="email1" class="block text-900 text-xl font-medium mb-2"
			>Email</label
		>
		<input
			id="email1"
			type="text"
			[(ngModel)]="email"
			pInputText
			class="w-full mb-3"
		/>
		<small class="p-error" *ngIf="!email || email === ''">Requerido</small>
	</div>
	<ng-template pTemplate="footer">
		<p-button
			*ngIf="!loading"
			label="Continuar"
			styleClass="p-button-rounded mt-4"
			(click)="resetPassword()"
		></p-button>
	</ng-template>
</p-dialog>
